import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import * as actions from '../../actions';
import _ from 'lodash';
import {URL} from '../../config/Config';
import {setRequiredDataFormat, setSwitchValue, deleteUnnecessaryFields, initialClean} from '../../utils/prepareData';
import {mmCodes, fieldsToDelete, wtFieldsToDelete, dwdFieldsToDelete, metricConversion, convertStringToNumber, parseNumberToString} from '../../utils/helpers';
import {Maybe, logging} from '../../utils/logging';
import {getTranslate, getActiveLanguage} from 'react-localize-redux';
import {setLanguageIndex} from '../../utils/helpers';

class FormInputField extends Component {

	// constructor
	constructor(props) {
		super(props);
		this.state = {
			// [this.props.name]: this.props.value,
            [this.props.name]: this.props.value,
			// [this.props.radioName]: this.props.value,
		};
        this.handleInputChange= this.handleInputChange.bind(this);
        this.callDebounce = _.debounce(this.callDebounce, 300);
    }

    componentDidMount() {
        window.$('select').material_select();
        //window.$('select').on('change',function(){console.log('select has changed to:',window.$(this).val());});
        window.$(ReactDOM.findDOMNode(this.refs[this.props.name])).on('change',this.handleInputChange.bind(this));
    }

    componentDidUpdate() {
        //console.error(this.props.bathtub)
        window.$('select').material_select();
    }

    getAction(name, value){
        const article = name.split('.')[0];
        const [articleName, field] = name.split('.');
        switch(articleName) {

            case 'DWDF':
                this.props.changeData(field, value, 'DWDF', this.props.articleID)
                    .then((state) => {
                        return this.props.fetchImage(
                            state.dwdf,
                            'dwdf',
                            this.props.articleID
                        );
                    })
                    .then((result) => {
                        // update data for select change
                        const selectFields = [];
                        if (selectFields.some((el) => {
                            return el === field;
                        })) {
                            // set Z switch field
                            let newState = setSwitchValue(this.props.dwdf, ['Z23', 'Z45', 'Z67', 'Z81']);
                            // set S switch field
                            newState = setSwitchValue(this.props.dwdf, ['S23', 'S45', 'S67', 'S81']);
                            // set data format (code:value) required for POST
                            newState = setRequiredDataFormat(newState);
                            // transform from cm to mm
                            mmCodes.forEach((code) => {
                                const currentValue = convertStringToNumber(newState[code]);
                                newState[code] = metricConversion(currentValue, 'cm', 'mm').toString();
                            });
                            // clean data
                            newState = initialClean(newState, ['-']);
                            // delete local data
                            newState = deleteUnnecessaryFields(newState, dwdFieldsToDelete);

                            // change GT to string
                            Maybe.of(parseNumberToString(newState.GT)._value)
                            .map((value) => {
                                newState.GT = value;
                            })

                            // change OT to string
                            Maybe.of(parseNumberToString(newState.OV)._value)
                            .map((value) => {
                                newState.OV = value;
                            })


                            // set data for POST
                            const data = {
                                Features:    newState,
                                Evaluate:    'true',
                                BaseArticle: this.props.articleID,
                            };
                            // call API
                            return this.props.fetchData(`${URL}data`, 'POST', data, 'dwdf')
                        }
                    })
                break;
            case 'BATHTUB':
                this.props.changeData(field, value, 'BATHTUB', this.props.articleID)
                    .then((state) => {
                        return this.props.fetchImage(
                            state.bathtub,
                            'bathtub',
                            this.props.articleID
                        );
                    })
                    .then((result) => {
                        // update data for select change
                        const selectFields = ['SPV', 'ALGV', 'GR', 'GFP1', 'GFP2', 'GFT1', 'WS', 'ALG'];
                        if (selectFields.some((el) => {
                            return el === field;
                        })) {
                            // set Z switch field
                            let newState = setSwitchValue(this.props.bathtub, ['Z23', 'Z45', 'Z67', 'Z81']);
                            // set data format (code:value) required for POST
                            newState = setRequiredDataFormat(newState);
                            // transform from cm to mm
                            mmCodes.forEach((code) => {
                                const currentValue = convertStringToNumber(newState[code]);
                                newState[code] = metricConversion(currentValue, 'cm', 'mm').toString();
                            });
                            // clean data
                            newState = initialClean(newState, ['-']);
                            // delete local data
                            newState = deleteUnnecessaryFields(newState, fieldsToDelete);
                            // set data for POST
                            const data = {
                                Features:    newState,
                                Evaluate:    'true',
                                BaseArticle: this.props.articleID,
                            };
                            // refetch data & image for dependent options
                            if( field === "GFT1" ) {
                                this.props.fetchData(`${URL}data`, 'POST', data, 'bathtub')
                                    .then(([currentState, article, articleID]) => {
                                        return this.props.fetchImage(currentState[article], article, articleID);
                                    });
                            } else {
                                return this.props.fetchData(`${URL}data`, 'POST', data, 'bathtub');
                            }
                        }
                    })
                break;
            case 'WT':
                this.props.changeData(field, value, 'WT', this.props.articleID)
                    .then((state) => {
                        return this.props.fetchImage(
                            state.wt,
                            'wt',
                            this.props.articleID
                        );
                    })
                    .then((result) => {
                        // update data for select change
                        const selectFields = ['WT_ALAZ', 'W_BREITE', 'WT_TIEFE', 'ST'];
                        if (selectFields.some((el) => {
                            return el === field;
                        })) {
                            // set data format (code:value) required for POST
                            let newState = setRequiredDataFormat(this.props.wt);
                            // transform from cm to mm
                            mmCodes.forEach((code) => {
                                const currentValue = convertStringToNumber(newState[code]);
                                newState[code] = metricConversion(currentValue, 'cm', 'mm').toString();
                            });
                            // clean data
                            newState = initialClean(newState, ['-']);
                            // delete local data
                            let newFieldsToDelete = [...wtFieldsToDelete, this.props.wt.WT_AM.isInvalidRange ? "WT_AM" : "DUMMY"];
                            newState = deleteUnnecessaryFields(newState, newFieldsToDelete);
                            // set data for POST
                            const data = {
                                Features:    newState,
                                Evaluate:    'true',
                                BaseArticle: this.props.articleID,
                            };
                            // call API
                            return this.props.fetchData(`${URL}data`, 'POST', data, 'wt')
                        }
                    })
                break;
            case 'KRW':
                this.props.changeData(field, value, 'KRW', this.props.articleID)
                    .then((state) => {
                        return this.props.fetchImage(
                            state.krw,
                            'krw',
                            this.props.articleID
                        );
                    })
                    .then((result) => {
                        // update data for select change
                        const selectFields = [];
                        if (selectFields.some((el) => {
                            return el === field;
                        })) {
                            // set SICHTKANTEN switch field
                            let newState = setSwitchValue(this.props.krw, ['SK23', 'SK45', 'SK67', 'SK81']);
                            // set data format (code:value) required for POST
                            newState = setRequiredDataFormat(newState);
                            // transform from cm to mm
                            mmCodes.forEach((code) => {
                                const currentValue = convertStringToNumber(newState[code]);
                                newState[code] = metricConversion(currentValue, 'mm', 'mm').toString();
                            });
                            // clean data
                            newState = initialClean(newState, ['-']);
                            // delete local data
                            newState = deleteUnnecessaryFields(newState, fieldsToDelete);
                            // set data for POST
                            const data = {
                                Features:    newState,
                                Evaluate:    'true',
                                BaseArticle: this.props.articleID,
                            };
                            // refetch data
                            return this.props.fetchData(`${URL}data`, 'POST', data, 'krw');

                        }
                    })
                break;
            default:
                return;

        }
    }

	handleEvent(target) {
        switch(target.type) {

            case 'checkbox':
                this.getAction(target.name, target.checked === true ? '1' : '0');
                return target.checked ? '1' : '0';
            case 'number':
                // return parseInt(target.value) + 1;
            case 'text':
            case 'textarea':
                // this.getAction(target.name, target.value);
                return target.value;
            default:
                this.getAction(target.name, target.value);
                return target.value;

        }
	}

    setDebounce(name, val) {
        const [articleName, field] = name.split('.');
        this.props.isFormValid();
        if(this.props.type === 'number'){
            if(this.props.max === undefined){
                this.props.changeData(field, val, articleName, this.props.articleID);
                this.callDebounce(name, val);
                return;
            }
            if(val > this.props.max) {
                val = this.props.max;
            } else if(val >= this.props.min){
                this.callDebounce(name, val);
            }
            this.props.changeData(field, val, articleName, this.props.articleID);
            return;
        }
        this.props.changeData(field, val, articleName, this.props.articleID);
        this.callDebounce(name, val);
    }

    callDebounce(name, val) {
        this.getAction(name, val);
    }

    handleInputChange({target}) {
        const name = target.name;
        this.setState({
            [name]: this.handleEvent(target),
        });
        // this.callDebounce(target)
    }

	renderField(type) {
		switch(type) {

            case 'textarea':
                return (
					<textarea
						name={this.props.name}
						className={this.props.classes}
                        value={this.props.value}
						maxLength={this.props.maxLength}
						placeholder={this.props.placeholder}
                        disabled={this.props.disabled}
                        readOnly={this.props.readOnly}
                        onChange={(e) => {this.setDebounce(e.target.name, e.target.value)}} >
						{this.props.value}
					</textarea>
                );
            case 'text':
                return (
					 <input
						 type='text'
                         className='text-field'
						 style={this.props.inputStyle}
						 name={this.props.name}
                         value={this.props.value}
                         placeholder={this.props.placeholder}
                         disabled={this.props.disabled}
                         readOnly={this.props.readOnly}
                         onChange={(e) => {this.setDebounce(e.target.name, e.target.value)}} />
                );
            case 'number':
                return (
                    <input
                        type='number'
                        style={this.props.inputStyle}
                        className='center-align number-field'
                        name={this.props.name}
                        value={this.props.value}
                        disabled={this.props.disabled}
                        readOnly={this.props.readOnly}
                        min={
                            this.props.min || this.props.min === 0
                                ? this.props.min
                                : null
                        }
                        max={
                            this.props.max || this.props.max === 0
                                ? this.props.max
                                : null
                        }
                        step={this.props.step || '1'}
                        onChange={(e) => {this.setDebounce(e.target.name, e.target.value)}}
                    />
                );
            case 'checkbox':
                return (
					<span>
						<input
							type={this.props.type}
							name={this.props.name}
							value={this.props.value}
							checked={this.props.value === '1'}
							onChange={this.handleInputChange}
                            disabled={this.props.disabled}
							id={`${this.props.name}-${this.props.value}`}
							className='filled-in' />
						<label
							htmlFor={`${this.props.name}-${this.props.value}`}
							className='config-step__input-wrapper--checkbox'
							style={{margin: '10px 0'}}>
                            <div className='form-input' style={this.props.inputStyle}>{this.props.labelName}</div>
						</label>
					</span>

                );
            case 'radio':
                return (
					<span className={this.props.divClass}>
						<input
							style={this.props.style}
							className='with-gap'
							type='radio'
							id={`${this.props.name}-${this.props.value}`}
							name={this.props.name}
							value={this.props.value}
							defaultChecked={this.props.checked === this.props.value}
                            disabled={this.props.disabled}
							onClick={this.handleInputChange} />
						<label htmlFor={`${this.props.name}-${this.props.value}`} style={{marginTop: '5px', marginLeft: '-14px'}}>&nbsp;</label>
					</span>
                );
			case 'select':
                let options;
                if (Array.isArray(this.props.options)) {
                    options = (this.props.options && (this.props.options.length > 1))
                        ? this.props.options.sort((a, b) => {
                            return parseInt(a.Code) - parseInt(b.Code);
                        })
                        : this.props.options;
                } else {
                    options = [this.props.options].filter(Boolean);
                }

                return (
					<select
						ref={this.props.name}
						name={this.props.name}
                        disabled={this.props.disabled}
						onChange={this.handleInputChange}
                        inputstyle={this.props.inputStyle}
						value={this.props.value}>
                        {options.length > 0 ?
                        options.map(
                            (option, index) => {
                                if (index === 0) {
                                    return (
                                        <option
                                            defaultValue={option.Code}
                                            value={option.Code}
                                            key={index}>
                                            {option.Description[`${setLanguageIndex(this.props.currentLanguge)}`]}
                                        </option>
                                    )
                                }
                                return (
									<option
                                        disabled={option.Code === '-'}
										value={option.Code}
										key={index}>
                                        {option.Description[`${setLanguageIndex(this.props.currentLanguge)}`]}
									</option>
                                );
                            },
                        ) :
                            <option
                                value=''>
                                No option to select
                            </option>
                        }
					</select>
                );
            default:
                return <div />;

}
	}

	// render
	render() {
		return this.renderField(this.props.type);
	}

}

function mapStateToProps({bathtub, wt, dwdf, articleID, locale}) {
    return {
        bathtub,
        wt,
        dwdf,
        articleID,
        currentLanguge: getActiveLanguage(locale).code,
    }
}

/**
 * Prop types
 * @type {{tempDetails: *}}
 */
FormInputField.propTypes = {
    value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
    ]),
    id:            PropTypes.string,
	classes:       PropTypes.string,
	maxLength:     PropTypes.number,
    divClass:      PropTypes.string,
	placeholder:   PropTypes.string,
	labelPosition: PropTypes.string,
	labelName:     PropTypes.string,
    checked: PropTypes.oneOfType([
         PropTypes.string,
         PropTypes.bool,
    ]),
    options: PropTypes.oneOfType([
         PropTypes.array,
         PropTypes.object,
    ]),
	type: 		          PropTypes.string,
	inputStyle: 	     PropTypes.object,
	name: 			         PropTypes.string,
	style: 			        PropTypes.object,
    onCheckboxChange: PropTypes.func,
    disabled:         PropTypes.bool,
	min: 			    PropTypes.number,
	max: 	    PropTypes.number,
    step:             PropTypes.number,
    isFormValid:      PropTypes.func.isRequired,
};

export default connect(mapStateToProps, actions)(FormInputField);



// WEBPACK FOOTER //
// ./src/components/forms/FormInputField.js